import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "GradingSettingList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading,
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      isFilterOpen: false,
      searchName: "",
      gradingSettingData: {},
      searchedName: null,
    };
  },

  methods: {
    getList(page = 1) {
      this.isLoading = true;
      const params = {};
      if (this.searchedName) {
        params.name = this.searchedName;
      }
      axios.get("gradingSetting/list?page=" + page, { params })
        .then((res) => {
          this.gradingSettingData = res.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    search() {
      this.searchedName = this.searchName ? this.searchName.trim() : null;
      this.getList(1);
    },

    reset() {
      this.searchName = "";
      this.searchedName = null;
      this.getList(1);
    },

    handlePaginate(page) {
      this.getList(page);
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteSetting(id);
      }
    },

    deleteSetting(id) {
      this.isLoading = true;
      axios.delete("gradingSetting/delete/" + id)
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Grading Setting Deleted Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.getList(this.gradingSettingData.current_page || 1);
          } else {
            this.$notification.error(res.data.message || "Delete failed", {
              timer: 3,
              position: "bottomCenter",
            });
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Delete failed";
          this.$notification.error(msg, {
            timer: 3,
            position: "bottomCenter",
          });
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getList();
  },
};
